//import { type AxiosPromise } from "axios";
import CollapsibleSection from "components/DetailPage/CollapsibleSection";
import { Panel } from "components/panels";
import React from "react";
import { CreateClientTool } from "./CreateClientTool";
import { toastError, toastSuccess } from "components/Toast/Toast";

interface Props {
  config: server.dto.DashboardAdminOneUsefulLinksPanelConfig
}

const UsefulLinksPanel = ({ config }: Props) => {
  // const callExceptionEndpoint = async (endpoint: () => AxiosPromise<any>) => {
  //   try {
  //     await endpoint();
  //     alert("Server did NOT throw an error");
  //   } catch (e) {
  //     console.error(e);
  //     alert("Response:\n" + e.message);
  //   }
  // };

  return <Panel
    title={config.headerLabel}
    panelClassName="s1_dashboard-panel"
    contentCssClass="flex-column gap-larger"
  >
    {config.data.map(cat => (
      <CollapsibleSection
        key={cat.label}
        title={cat.label}
        collapsible="startOpen"
        uniqueRowId={`adminOneUsefulLinks-${cat.label}`}
      >
        {cat.items.map(item => (
          <div key={item.label}>
            <a href={item.url} target={item.target} rel={(item.target) ? "noreferrer" : null}>{item.label}</a>
          </div>
        ))}
      </CollapsibleSection>
    ))}

    <CollapsibleSection
      title={"Developer tools"}
      collapsible="startOpen"
      uniqueRowId={`adminOneUsefulLinks-developerTools`}
    >
      <div>
        <a onClick={() => { throw new Error("Test error"); }}>Throw JavaScript exception</a>
      </div>
      <div>
        <a href="/189189819819891189">Request nonexistent page (404)</a>
      </div>
      <div>
        <a onClick={() => toastError("This is a test error toast")}>Show error toast</a>
      </div>
      <div>
        <a onClick={() => toastSuccess("This is a test success toast")}>Show success toast</a>
      </div>
      <div>
        <CreateClientTool />
      </div>
    </CollapsibleSection>
  </Panel>;
};

export default UsefulLinksPanel;